import { Arrow } from "@sphtech/dmg-design-system";

export const moreIcon = <Arrow size={16} strokeWidth={1.5} />;
